"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiDialogTitle = void 0;
var typography_1 = require("../../../theme/global/typography");
var palette_1 = require("../../global/palette");
exports.MuiDialogTitle = {
    root: __assign(__assign({}, typography_1.typography.h5), { padding: '24px 36px 16px 24px', color: palette_1.palette.common.black, display: 'flex', justifyContent: 'space-between', '& svg': {
            width: 12,
            height: 12,
            fill: palette_1.palette.common.black,
        }, '& Button': {
            position: 'absolute',
            right: 8,
            top: 8,
        } }),
};
